exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.trumbowyg-box {\n    margin: 0;\n    border: 0;\n}\n.trumbowyg-editor {\n        background: white;\n        font-weight: lighter;\n}\n", ""]);

// exports
